module.exports = __webpack_public_path__ + "static/media/Torpedo Group.751ebd87.png";